import { convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import React from 'react';
import { stateFromHTML } from 'draft-js-import-html';
import draftToHtml from 'draftjs-to-html';
import { Box, useTheme } from '@mui/material';

interface CerebroRichTextProps {
	placeholder?: string;
	value: string;
	onChange: (updatedValue: string) => void;
}

export const CerebroRichText: React.FC<CerebroRichTextProps> = ({ placeholder, value, onChange }) => {
	const theme = useTheme();

	const [editorState, setEditorState] = React.useState<EditorState>(() =>
		EditorState.createWithContent(stateFromHTML(value))
	);

	const onEditorStateChange = (editorState: EditorState) => {
		const forFormik = draftToHtml(convertToRaw(editorState.getCurrentContent()));
		onChange(forFormik);
		setEditorState(editorState);
	};

	return (
		<Box sx={{ marginBottom: 3 }}>
			<Editor
				editorStyle={{
					border: '1px solid',
					borderRadius: '5px',
					boxShadow: '2px 2px 2px 2px' + theme.palette.gray.light,
				}}
				toolbar={{
					options: ['inline', 'list', 'remove'],
					inline: {
						options: ['bold', 'italic', 'underline'],
					},
					remove: {
						options: ['eraser'],
					},
				}}
				placeholder={placeholder}
				editorState={editorState}
				spellCheck={true}
				onEditorStateChange={onEditorStateChange}
			/>
		</Box>
	);
};
